import { RecordStatus } from '../menu/enums.types';

// Premise Type Enum
export enum PremiseType {
  OFF_PREM = 'Off Prem',
  ON_PREM = 'On Prem',
}

// Seating Type Enum
export enum SeatingType {
  RESTAURANT = 'Restaurant',
  PRIVATE_ROOM = 'Private Room',
  ROOF_TOP = 'Roof Top',
  GARDEN_VIEW = 'Garden View',
  PATIO_OUTDOOR = 'Patio / Outdoor',
  LOUNGE = 'Lounge',
  BAR_AREA = 'Bar Area',
  POOLSIDE = 'Poolside',
  TERRACE = 'Terrace',
  CHEFS_TABLE = "Chef's Table",
  WINDOW_SIDE = 'Window-side',
  EVENT_HALL = 'Event Hall',
  CABANA = 'Cabana',
  THEMED_ROOM = 'Themed Room',
}

export interface ICateringPackage {
  id: number;
  packageName: string;
  price: number;
  description: string;
  premiseType: PremiseType;
  seatingType: SeatingType[];
  minimumGuest: number;
  maximumGuest?: number;
  includes?: string;
  isActive: boolean;
  status?: RecordStatus;
  restaurantId?: number;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface CateringPackages {
  cateringPackages: ICateringPackage[];
}

export interface CateringPackageDetails {
  cateringPackage: ICateringPackage;
}
export interface CreatePackage {
  packageName: string;
  description: string;
  includes: string;
  price: number;
  minimumGuest: number;
  maximumGuest: number;
  premiseType: string;
  seatingType: never[];
}

export interface UpdatePackage extends CreatePackage {
  id: number;
}

export enum CateringPackageFilter {
  ON_PREM = 'On premises',
  OFF_PREM = 'Off premises',
  ARCHIVED = 'Archived',
}

export enum CateringPackagePremiseType {
  ON_PREM = 'On premises',
  OFF_PREM = 'Off premises',
}

export enum CateringPackageMenuType {
  CATEGORY = 'category',
  SUBCATEGORY = 'subcategory',
  ITEM = 'item',
  MENU = 'menu',
}

export enum CateringPackageModule {
  ORDER = 'order',
}

export interface ICtrItem {
  id: number;
  name: string;
  price: number;
}

export interface ICtrCategory {
  id: number;
  name: string;
  type: CateringPackageMenuType.CATEGORY | CateringPackageMenuType.SUBCATEGORY;
  children?: ICtrCategory[];
  items?: ICtrItem[];
}

export interface ICtrMenu {
  id: number;
  name: string;
  type: CateringPackageMenuType.MENU;
  children: ICtrCategory[];
}

export enum CateringPackageSchedulingType {
  START = 'start',
  END = 'end',
}
